
















import {
  computed,
  defineComponent,
  onUnmounted,
  onUpdated,
} from '@vue/composition-api';
import { SpinnerBindings, SpinnerProps } from './types';

export const DATA_TEST_ID = 'testid--spinner';

export default defineComponent<SpinnerProps, SpinnerBindings>({
  name: 'Spinner',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: 'Processing...',
    },
    withOverlay: {
      type: Boolean,
      default: true,
    },
    fullScreen: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    onUpdated(() => {
      const body = document.getElementsByTagName('BODY')[0] as HTMLElement;
      if (props.active) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = 'initial';
      }
    });

    onUnmounted(() => {
      const body = document.getElementsByTagName('BODY')[0] as HTMLElement;
      body.style.overflow = 'initial';
    });

    return {
      testId: DATA_TEST_ID,
      containerClasses: computed(() => ({
        'has-overlay': props.withOverlay,
        'is-full-screen': props.fullScreen,
      })),
    };
  },
});
